import * as Sentry from "@sentry/react";

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_LOGOUT = 'LOGIN_LOGOUT';

//TODO:
// export const checkLoginAction = () => {
//     let user = null;
//     const persistedUser = sessionStorage.getItem('user');
//     if (persistedUser !== null) {
//         user = JSON.parse(persistedUser);
//     }

//     return { type: LOGIN_SUCCESS, user };
// };

export const logoutAction = () => {
    Sentry.setUser(null);
    
    return {
        type: LOGIN_LOGOUT
    };
};

export const loginAction = user => {
    // Gate Sentry.setUser behind explicit PII consent
    // sendDefaultPii only controls automatic PII collection (e.g., IP addresses)
    // Explicit setUser calls require separate consent check
    const allowPii = process.env.REACT_APP_SENTRY_SEND_PII === 'true';
    
    if (user && allowPii) {
        Sentry.setUser({
            id: user.userId?.toString(),
        });
    } else {
        Sentry.setUser(null);
    }
    
    return { type: LOGIN_SUCCESS, user };
};

export const userReducer = (state = null, action) => {
    if (action.type === LOGIN_SUCCESS) {
        return action.user;
    }
    if (action.type === LOGIN_LOGOUT) {
        sessionStorage.removeItem('user');
        return null;
    }

    return state;
};
